export function deleteUser(user) {
    let { deleteUserRequest, deleteUserError, deleteUserResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_user',
        this.createBundle('delete_user', { user }, this.POST, deleteUserRequest, deleteUserResult, deleteUserError)
    )
}
